import React, { Fragment, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, Dialog, withMobileDialog } from '@material-ui/core'
import TextField from './TextField'
import S3Manager from 'components/S3Manager'
import Button from 'components/theme/Button'
import { handleFormValueChange } from 'actions/signupForm/addOrEdit'
import language from 'utils/vast-languagepack'
import { read } from 'actions/data'

const setLogo = payload => dispatch =>
  dispatch({ type: 'setLogoForms', payload })

const Logo = ({ handleFormValueChange, fullScreen, formID, read, setLogo }) => {
  const [dialogOpen, toggleDialog] = useState(false)

  useEffect(() => {
    if (formID === 'new') {
      read('', 'account/preference', null, 'none').then(prefs => {
        if (prefs?.preferences?.company_logo_url_color) {
          setLogo(prefs?.preferences?.company_logo_url_color)
        }
      })
    }
  })

  return (
    <Fragment>
      <Grid
        style={{ backgroundColor: '#fff' }}
        justify="center"
        container
        spacing={24}
      >
        <Grid item style={{ textAlign: 'center' }}>
          <TextField property="logoURL" label="Logo URL" />
          <Button
            color="secondary"
            variant="contained"
            onClick={() => toggleDialog(true)}
          >
            {language.signupform.add.logoBrowse}
          </Button>
        </Grid>
      </Grid>
      <Dialog
        fullScreen={fullScreen}
        onClose={() => toggleDialog(false)}
        fullWidth
        open={dialogOpen}
      >
        <S3Manager
          clickFile={url => {
            toggleDialog(false)
            handleFormValueChange('logoURL', url)
          }}
        />
      </Dialog>
    </Fragment>
  )
}

export default connect(
  state => ({ formID: state.signupForm.addOrEdit.formID }),
  dispatch =>
    bindActionCreators({ handleFormValueChange, read, setLogo }, dispatch),
)(withMobileDialog({ breakpoint: 'sm' })(Logo))
